<template>
  <div class="financial_flow">
    <van-sticky>
      <van-nav-bar title="财务流水" left-arrow @click-left="goback()" />
    </van-sticky>
    <van-pull-refresh v-model="isLoading" @refresh="onRefresh">
      <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad" :immediate-check="false">
        <div class="flow_list" v-for="(item, index) in dataList" :key="index" @click="toFlowDetail(item)">
          <div class="list_detail">
            <div>订单编号：{{item.order_info_orderNumber}}</div>
            <div class="color999 fs12 ">到账时间：{{item.createtime}}</div>
          </div>
          <div style="font-size: 14px;width: 35%;text-align: right;color:#67C565">
            + {{item.amount}}
          </div>
          <van-icon name="arrow" size="12" />
        </div>
      </van-list>
    </van-pull-refresh>
    <van-button color="#0CA7F0" block @click="toWithdraw()">申请提现</van-button>
  </div>
</template>
<script>
import storage from "@/utils/storage";
import { Button, NavBar, Icon, Sticky, Toast, PullRefresh, List, Notify } from "vant";
export default {
  components: {
    [Button.name]: Button,
    [Icon.name]: Icon,
    [NavBar.name]: NavBar,
    [Sticky.name]: Sticky,
    [PullRefresh.name]: PullRefresh,
    [List.name]: List,
  },
  data() {
    return {
      searchValue: "",
      active: 0,
      title: ["全部", "待跟进", "已跟进"],
      loading: false, //底部加载状态
      finished: false, //底部是否完成状态
      isLoading: false,
      page: 1,
      size: 20,
      dataList: [],
      total:0,
    };
  },
  mounted() {
    this.getFlowList();
  },
  methods: {
    //返回上一页
    goback() {
      this.$router.go(-1);
    },

    //点击跳转流水详情页面
    toFlowDetail(item) {
      storage.setFlowId(item.order_info_id)
      this.$router.push({ path: "/place/flowDetail" });
    },

    //点击跳转申请提现页面
    toWithdraw() {
      this.$router.push({ path: "/place/withdraw" });
    },

    //获取流水列表
    getFlowList(isLoadMore = false) {
      let that = this;
      that.$api.siteSupplierFlowListAPI({
        page: that.page,
        size: that.size,
      }).then(function(res) {
        if (res.data.code == 200) {
          if (that.page > 1) {
            that.dataList = (!isLoadMore && res.data.dataList.length != 0) ? res.data.dataList : that.dataList;
            that.dataList = (isLoadMore && res.data.dataList.length != 0) ? that.dataList.contact(res.data.dataList) : that.dataList
          } else {
            that.dataList = res.data.dataList
          }
          that.total = res.data.total
          if (res.data.dataList.length == 0 && that.page > 1)
            that.finished = true
        } else {
          Notify({ type: "danger", message: '接口返回异常：' + res.data.message });
        }
      }).catch(function(err) {
        Notify({ type: "danger", message: JSON.stringify(err) });
      })
    },

    //下拉刷新
    onRefresh() {
      let that = this
      that.page = 1;
      setTimeout(() => {
        that.isLoading = false
        that.getFlowList()
      }, 1000);
    },

    //上拉加载
    onLoad() {
      let that = this;
      that.page = that.page + 1
      setTimeout(() => {
        that.getFlowList(true);
      }, 1000);
    },
  }
};

</script>
<style lang="less" scoped>
.financial_flow {
  .flow_list {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    margin: 0px 15px;
    padding-top: 10px;
    border-bottom: 1px solid #eaeaea;

    .list_detail {
      display: flex;
      flex-direction: column;
      font-size: 14px;

      div {
        margin-bottom: 10px;
      }
    }
  }

  .van-button {
    position: fixed;
    bottom: 0px;
    font-size: 16px;
  }
}

</style>



// WEBPACK FOOTER //
// src/views/layout/place/financialFlow.vue